export enum ConnectionsActionsHeapEvents {
  addProfile = 'add-profile',
  removeProfile = 'remove-profile',
}
